<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12 text-center p-3">
                <LeafletComponent
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    @isPanning="(e) => isPanning = e"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';

    export default {
        props: ['recinto_id', 'evento_id', 'sesion_id'],
        data() {
            return {
                svg_loaded : '',
                loading: true,
                svgpanzoom: null,
                svg: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                ocupadaColor: 'red', 
                seleccionadaColor: '#8CA9D9',
                bloqueadaColor: '#BF95C4',
                reservadoColor: "#EAAA00",
                vendidaEventosColor: 'red',
                svgRendered: null,
                isPanning: false, 
                plazas: null
            }            
        },
        created() {
            this.getPlazas();   
        },
        methods: {
            getPlazas(){
                this.loading = true;

                const params = {
                    recinto_id: this.recinto_id,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                };


                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.plazas.taquilla'), params)
                    .then(res => {
                        this.plazas = res.data.data;
                        this.getSvg()
                        this.loading = true
                    })
            },
            getSvg() {
                this.loading = true;
                const params = {
                    recinto_id: this.recinto_id
                };
                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params)
                    .then(({ data: { svg } }) => {
                        this.renderLeafletSvg(svg);
                        this.loading = false;
                    }).catch(error => {
                        console.log(error);
                        console.warn('Error al recuperar el SVG del recinto anexo');
                    });
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;

                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');

                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                    if (plaza) {
                        if (plaza.ocupada.bloqueada) {
                            const title = this.getButacaName(plaza);
                            this.drawPopover(circle, null, title, plaza);
                            if(plaza.ocupada.reserva_id) {
                                circle.setAttribute('fill', this.reservadoColor);
                            } else {
                                circle.setAttribute('fill', this.bloqueadaColor);
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                    setTimeout(() => {
                                        if (!this.isPanning) {
                                            if (!isSeleccionado) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            } else {
                                                circle.setAttribute('fill', this.bloqueadaColor);
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickButaca(plaza.id);
                                        }
                                    }, 150);
                                });
                            }
                        } else {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                        }
                    }
                });

                this.svgRendered = tempDiv.firstElementChild;
            },

            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },

            clickButaca(plaza_id) {
                let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
                if (plaza.ocupada.bloqueada && ! plaza.ocupada.reserva_id) {
                    this.$emit('clickPlaza', this.plazas, plaza);
                } else {
                    this.$toast.error('Asiento no disponible.')
                }
            },
            getButacaName(butaca) {
                const nButaca = butaca.butaca;
                const nFila = butaca.fila;
                const sector = butaca.sector_name;
                const visibilidad_reducida = butaca.visibilidad_reducida;
                const porcentaje_visibilidad = butaca.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${butaca.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            drawPopover(circle, content, title = null, butaca = null) {
                let contentFormatted = '';
                if (butaca) {
                    if(butaca.ocupada.reserva_id) {
                        contentFormatted += '<b>Reservada</b><br>'
                    }

                    const preciosContent = this.generatePriceContent(butaca.precios);
                    if (preciosContent !== '') {
                        contentFormatted += '<b>Precios:</b>';
                        contentFormatted += preciosContent;
                    }
                }

                const popoverOptions = {
                    title: title,
                    content: content ?? contentFormatted,
                    trigger: 'hover',
                    html: true
                }

                new Popover(circle, popoverOptions);
            },
            generatePriceContent(precios) {
                let content = '';

                content += '<ul class="pb-0 mb-0">';
                if (precios && precios.length > 0) {
                    precios.forEach(precio => {
                        content += `<li>${precio.description}: ${precio.precio + ' €'}</li>`;
                    });
                } else {
                    content += '<li>No tiene precios configurados</li>'
                }
                content += '</ul>';

                return content;
            },
        },
        components: { LeafletComponent }
    }
</script>